// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1j5ys","signatureButtonsRight":"ModalSign_signatureButtonsRight__2orkB"};